export default __webpack_public_path__ + "static/prof-home-mobile-d20511e9b7ea1cb8b3afafc7dae3abf6.png";